import { FC } from 'react';

import StructuredData from 'components/common/structured-data';
import { getCanonicalUrl } from 'utils/url';

import { IBreadcrumbStructuredDataProps } from './types';

export const BreadcrumbStructuredData: FC<IBreadcrumbStructuredDataProps> = ({
  crumbs,
}) => {
  return (
    <StructuredData
      data={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: crumbs.map(({ slug, label }, index) => {
          return {
            '@type': 'ListItem',
            position: index + 1,
            name: label,
            item:
              !slug || index === crumbs.length - 1
                ? undefined
                : getCanonicalUrl('/' + slug),
          };
        }),
      }}
    />
  );
};
